import * as authService from "@/data/api/auth"

interface UserSession {
  userId: number,
  userName: string,
  sessionId: string,
  expirationTimestamp: string,
  firstName: string,
  lastName: string,
  micadUser: boolean,
  roles: Role[]
}

interface Role {
  id: number,
  name: string
}

export async function getUserSession(userId: number, sessionId: string | null): Promise<UserSession | null> {
  if (process.env.NODE_ENV === "test") {
    return null
  }
  try {
    if (!userId || !sessionId) {
      authService.authenticate()
      return null
    }
    const r = await authService.api.get("/api/user/session", {params: {userId, sessionId}})
    if (!r) {
      return null
    }
    return r.data as UserSession
  } catch (err) {
    console.error("getUserSession", err)
    return null
  }
}
